import React from 'react';
import { DefaultShirtStore } from '../../../../assets/images/imagesPNG';
import { ImageSlide } from './StoreStyles';

export const DefaultPic = (
  <div style={{ position: 'relative' }}>
    <ImageSlide src={DefaultShirtStore} />
  </div>
);
